import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { MfaService } from '../../mfa/services/mfa.service';
import { UpdatePasswordRequest, UpdatePasswordResult } from '../models';
import { EnvironmentVariables } from '../../environment-variables';

@Injectable({
  providedIn: 'root',
})
export class PasswordService {
  private usersApi = `${this.environment.apiPath}/users`;

  constructor(
    private environment: EnvironmentVariables,
    private http: HttpClient,
    private mfaSvc: MfaService
  ) {}

  updatePassword(data: UpdatePasswordRequest) {
    return this.mfaSvc.getToken$().pipe(
      switchMap((resp) => {
        if (resp.status === 'accepted' || resp.status === 'notusingmfa') {
          return this.http
            .put<UpdatePasswordResult>(`${this.usersApi}/password`, {
              ...data,
              mfaToken: resp.mfaToken,
            })
            .pipe(
              catchError((err: HttpErrorResponse) =>
                of({
                  success: false,
                  errorText: err.message,
                } as UpdatePasswordResult)
              )
            );
        }
        return of({
          success: false,
          errorText: 'Change cancelled',
        } as UpdatePasswordResult);
      })
    );
  }
}
